import clsx from 'clsx';
import React from 'react';
import {Body, designSystemToken, Icon} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import {CreatorBrandSafetyVettingStatus} from '@/types/creatorBrandSafetyVetting';
import styles from './SafeCollabChip.module.scss';

type SafeCollabChipProps = {
  status: CreatorBrandSafetyVettingStatus;
  showLabel?: boolean;
  className?: string;
  testID?: string;
  onClick?: (e: React.MouseEvent) => void;
};

type StatusStyle = {
  bgColor: string;
  textColor: string;
  labelLocaleKey: string;
};

const getDisplayableStatuses: () => Partial<
  Record<CreatorBrandSafetyVettingStatus, StatusStyle>
> = () => ({
  approved: {
    bgColor: designSystemToken('semantic.bg.brand-secondary'),
    textColor: designSystemToken('semantic.fg.brand-secondary'),
    labelLocaleKey: 'Approved',
  },
  declined: {
    bgColor: designSystemToken('semantic.bg.danger-secondary'),
    textColor: designSystemToken('semantic.fg.danger'),
    labelLocaleKey: 'Rejected',
  },
  ready_for_review: {
    bgColor: designSystemToken('semantic.bg.warning-secondary'),
    textColor: designSystemToken('semantic.bg.warning'),
    labelLocaleKey: 'Ready for review',
  },
});

function SafeCollabChip({
  status,
  showLabel = true,
  className,
  testID,
  onClick,
}: SafeCollabChipProps) {
  const config = getDisplayableStatuses()[status];

  if (!config) {
    return null;
  }

  return (
    <div
      className={clsx(styles.chip, onClick && styles.clickable, className)}
      style={{
        backgroundColor: config.bgColor,
      }}
      data-testid={testID}
      onClick={onClick}
    >
      <Icon
        name="Navigation-Shopbag-Shield-Stroke"
        appearance="neutral"
        size="small"
        color={config.textColor}
      />
      {showLabel && (
        <Body size="md" color={config.textColor}>
          {translate(config.labelLocaleKey)}
        </Body>
      )}
    </div>
  );
}

export default SafeCollabChip;
